import { render, staticRenderFns } from "./tab-b.vue?vue&type=template&id=2e951c1b&"
import script from "./tab-b.vue?vue&type=script&lang=js&"
export * from "./tab-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports